<template>
  <div :class="[baseCss, 'relative']" :style="style">
    <div :class="[`${baseCss}-layer`, setTextColor(), `${baseCss}-layer-base`, 'absolute', 'w-full', 'h-full']">
      <table-layout :y-align="yAlign" :x-align="xAlign">
        <row>
          <cell>
            <slot />
          </cell>
        </row>
      </table-layout>
    </div>
    <div :style="back" :class="[`${baseCss}-back`, setBgColor(), `${baseCss}-layer-back`, 'pointer-events-none', 'absolute', 'w-full', 'h-full']" />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'ParallaxItem',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('parallax-item', [])
    }
  },
  computed: {
    style () {
      const height = this.$parent.height
      return {
        height,
        width: this.$parent.width,
        aspectRatio: !height ? this.$parent.aspectRatio.replace(':', '/') : height
      }
    },
    back () {
      return {
        backgroundImage: `url(${this.bgImage})`
      }
    }
  },
  props: {
    bgImage: {
      type: String
    },
    yAlign: {
      type: String,
      default: 'middle'
    },
    xAlign: {
      type: String,
      default: 'center'
    },
    color: {
      type: String,
      default: 'black'
    },
    colorLightness: {
      type: Number,
      default: null
    },
    bgColor: {
      type: String,
      default: 'transparent'
    },
    bgColorLightness: {
      type: Number,
      default: null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/parallax-item/parallax-item.vue